// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as EventsRouteImport } from './routes/events'
import { Route as HallOfFameRouteImport } from './routes/hall-of-fame'
import { Route as LessonsRouteImport } from './routes/lessons'
import { Route as MethodRouteImport } from './routes/method'
import { Route as PlayInjuryFreeRouteImport } from './routes/play-injury-free'
import { Route as PricesRouteImport } from './routes/prices'
import { Route as RangeRouteImport } from './routes/range'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as TvRouteImport } from './routes/tv'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedEmployeeRouteRouteImport } from './routes/_authenticated/employee/route'
import { Route as AuthenticatedMyBookingsRouteImport } from './routes/_authenticated/my-bookings'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as PracticeIndexRouteImport } from './routes/practice/index'
import { Route as PracticeSlugRouteImport } from './routes/practice/$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminAvailabilityRouteImport } from './routes/_authenticated/admin/availability'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated/admin/blog'
import { Route as AuthenticatedAdminBookingsRouteImport } from './routes/_authenticated/admin/bookings'
import { Route as AuthenticatedAdminCoachingRouteImport } from './routes/_authenticated/admin/coaching'
import { Route as AuthenticatedAdminEventsRouteImport } from './routes/_authenticated/admin/events'
import { Route as AuthenticatedAdminFeedbackRouteImport } from './routes/_authenticated/admin/feedback'
import { Route as AuthenticatedAdminHallOfFameRouteImport } from './routes/_authenticated/admin/hall-of-fame'
import { Route as AuthenticatedAdminMembershipsRouteImport } from './routes/_authenticated/admin/memberships'
import { Route as AuthenticatedAdminPricingRouteImport } from './routes/_authenticated/admin/pricing'
import { Route as AuthenticatedAdminStaffRouteImport } from './routes/_authenticated/admin/staff'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedEmployeeIndexRouteImport } from './routes/_authenticated/employee/index'
import { Route as AuthenticatedEmployeeAvailabilityRouteImport } from './routes/_authenticated/employee/availability'
import { Route as AuthenticatedEmployeeFeedbackRouteImport } from './routes/_authenticated/employee/feedback'
import { Route as AuthenticatedEmployeeLessonsRouteImport } from './routes/_authenticated/employee/lessons'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const HallOfFameRoute = HallOfFameRouteImport.update({
            id: '/hall-of-fame',path: '/hall-of-fame',getParentRoute: () => rootRouteImport
          })
const LessonsRoute = LessonsRouteImport.update({
            id: '/lessons',path: '/lessons',getParentRoute: () => rootRouteImport
          })
const MethodRoute = MethodRouteImport.update({
            id: '/method',path: '/method',getParentRoute: () => rootRouteImport
          })
const PlayInjuryFreeRoute = PlayInjuryFreeRouteImport.update({
            id: '/play-injury-free',path: '/play-injury-free',getParentRoute: () => rootRouteImport
          })
const PricesRoute = PricesRouteImport.update({
            id: '/prices',path: '/prices',getParentRoute: () => rootRouteImport
          })
const RangeRoute = RangeRouteImport.update({
            id: '/range',path: '/range',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ScheduleRoute = ScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => rootRouteImport
          })
const TvRoute = TvRouteImport.update({
            id: '/tv',path: '/tv',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedEmployeeRouteRoute = AuthenticatedEmployeeRouteRouteImport.update({
            id: '/employee',path: '/employee',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyBookingsRoute = AuthenticatedMyBookingsRouteImport.update({
            id: '/my-bookings',path: '/my-bookings',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const PracticeIndexRoute = PracticeIndexRouteImport.update({
            id: '/practice/',path: '/practice/',getParentRoute: () => rootRouteImport
          })
const PracticeSlugRoute = PracticeSlugRouteImport.update({
            id: '/practice/$slug',path: '/practice/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAvailabilityRoute = AuthenticatedAdminAvailabilityRouteImport.update({
            id: '/availability',path: '/availability',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBookingsRoute = AuthenticatedAdminBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminCoachingRoute = AuthenticatedAdminCoachingRouteImport.update({
            id: '/coaching',path: '/coaching',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminEventsRoute = AuthenticatedAdminEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminFeedbackRoute = AuthenticatedAdminFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminHallOfFameRoute = AuthenticatedAdminHallOfFameRouteImport.update({
            id: '/hall-of-fame',path: '/hall-of-fame',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMembershipsRoute = AuthenticatedAdminMembershipsRouteImport.update({
            id: '/memberships',path: '/memberships',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminPricingRoute = AuthenticatedAdminPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminStaffRoute = AuthenticatedAdminStaffRouteImport.update({
            id: '/staff',path: '/staff',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedEmployeeIndexRoute = AuthenticatedEmployeeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedEmployeeRouteRoute
          })
const AuthenticatedEmployeeAvailabilityRoute = AuthenticatedEmployeeAvailabilityRouteImport.update({
            id: '/availability',path: '/availability',getParentRoute: () => AuthenticatedEmployeeRouteRoute
          })
const AuthenticatedEmployeeFeedbackRoute = AuthenticatedEmployeeFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => AuthenticatedEmployeeRouteRoute
          })
const AuthenticatedEmployeeLessonsRoute = AuthenticatedEmployeeLessonsRouteImport.update({
            id: '/lessons',path: '/lessons',getParentRoute: () => AuthenticatedEmployeeRouteRoute
          })





const AuthenticatedAdminRouteRouteChildren = {
  AuthenticatedAdminAvailabilityRoute: AuthenticatedAdminAvailabilityRoute,AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRoute,AuthenticatedAdminBookingsRoute: AuthenticatedAdminBookingsRoute,AuthenticatedAdminCoachingRoute: AuthenticatedAdminCoachingRoute,AuthenticatedAdminEventsRoute: AuthenticatedAdminEventsRoute,AuthenticatedAdminFeedbackRoute: AuthenticatedAdminFeedbackRoute,AuthenticatedAdminHallOfFameRoute: AuthenticatedAdminHallOfFameRoute,AuthenticatedAdminMembershipsRoute: AuthenticatedAdminMembershipsRoute,AuthenticatedAdminPricingRoute: AuthenticatedAdminPricingRoute,AuthenticatedAdminStaffRoute: AuthenticatedAdminStaffRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteRouteWithChildren = AuthenticatedAdminRouteRoute._addFileChildren(AuthenticatedAdminRouteRouteChildren)




const AuthenticatedEmployeeRouteRouteChildren = {
  AuthenticatedEmployeeAvailabilityRoute: AuthenticatedEmployeeAvailabilityRoute,AuthenticatedEmployeeFeedbackRoute: AuthenticatedEmployeeFeedbackRoute,AuthenticatedEmployeeLessonsRoute: AuthenticatedEmployeeLessonsRoute,AuthenticatedEmployeeIndexRoute: AuthenticatedEmployeeIndexRoute
}

const AuthenticatedEmployeeRouteRouteWithChildren = AuthenticatedEmployeeRouteRoute._addFileChildren(AuthenticatedEmployeeRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,AuthenticatedEmployeeRouteRoute: AuthenticatedEmployeeRouteRouteWithChildren,AuthenticatedMyBookingsRoute: AuthenticatedMyBookingsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,ContactRoute: ContactRoute,EventsRoute: EventsRoute,HallOfFameRoute: HallOfFameRoute,LessonsRoute: LessonsRoute,MethodRoute: MethodRoute,PlayInjuryFreeRoute: PlayInjuryFreeRoute,PricesRoute: PricesRoute,RangeRoute: RangeRoute,ResetPasswordRoute: ResetPasswordRoute,ScheduleRoute: ScheduleRoute,TvRoute: TvRoute,BlogSlugRoute: BlogSlugRoute,PracticeSlugRoute: PracticeSlugRoute,BlogIndexRoute: BlogIndexRoute,PracticeIndexRoute: PracticeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)